'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _spec = require('../spec');

var styles = {
  grid: {
    boxSizing: 'border-box',
    margin: '0 auto'
  },
  gridFluid: {
    boxSizing: 'border-box',
    margin: '0 auto'
  },
  noPadding: {
    padding: 0
  }
};

Object.keys(_spec.breakpoints).forEach(function (breakpoint) {
  if (breakpoint === 'xs') {
    styles.grid[(0, _spec.media)(breakpoint)] = {
      width: '100%'
    };
  } else {
    styles.grid[(0, _spec.media)(breakpoint)] = {
      maxWidth: _spec.containers[breakpoint],
      padding: [0, 20]
    };
  }
});

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ../dist/grid/styles.js
// module id = 124
// module chunks = 0